import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export enum ACQUISITION_CHANNEL {
  WORKSPACE_INVITATION = 'WORKSPACE_INVITATION',
  PERSONAL_REFERRAL = 'PERSONAL_REFERRAL',
  INVESTOR_REFERRAL = 'INVESTOR_REFERRAL',
  SNS_ADVERTISEMENT = 'SNS_ADVERTISEMENT',
  ARTICLES = 'ARTICLES',
  SEARCH = 'SEARCH',
  ONLINE_COMMUNITY = 'ONLINE_COMMUNITY',
  BANNER_REMEMBER = 'BANNER_REMEMBER',
  BANNER_CAPA = 'BANNER_CAPA',
  BANNER_INNOFOREST = 'BANNER_INNOFOREST',
}

export const ACQUISITION_CHANNEL_LABEL = {
  [ACQUISITION_CHANNEL.WORKSPACE_INVITATION]: '구성원 초대',
  [ACQUISITION_CHANNEL.PERSONAL_REFERRAL]: '지인 소개',
  [ACQUISITION_CHANNEL.INVESTOR_REFERRAL]: '투자자 권유',
  [ACQUISITION_CHANNEL.ARTICLES]: '언론 기사',
  [ACQUISITION_CHANNEL.SNS_ADVERTISEMENT]: '광고 (인스타그램, 페이스북)',
  //   [ACQUISITION_CHANNEL.ARTICLES]: '콘텐츠 (링크드인)',
  [ACQUISITION_CHANNEL.SEARCH]: '검색 (구글, 네이버)',
  [ACQUISITION_CHANNEL.ONLINE_COMMUNITY]: '커뮤니티 (네이버 카페, 링크드인)',
  [ACQUISITION_CHANNEL.BANNER_REMEMBER]: '배너광고(리멤버)',
  [ACQUISITION_CHANNEL.BANNER_CAPA]: '배너광고(CAPA)',
  [ACQUISITION_CHANNEL.BANNER_INNOFOREST]: '배너광고(혁신의숲)',
};

export interface AcquisitionChannelResponse {
  items: ACQUISITION_CHANNEL[];
}

export const getAcquisitionChannel = async (userId: string) => {
  return API.get<ResponseBaseWithData<AcquisitionChannelResponse>>(
    `/api/v3/users/${userId}/acquisition-channel-types`,
  );
};

export const postAcquisitionChannel = ({
  userId,
  request,
}: {
  userId: string;
  request: {
    acquisitionChannels: ACQUISITION_CHANNEL[];
  };
}) => {
  return API.post<ResponseBaseWithData<AcquisitionChannelResponse>>(
    `/api/v3/users/${userId}/acquisition-channels`,
    {
      data: request,
    },
  );
};

export type CompanyUserRole = 'MEMBER' | 'MASTER' | 'BANNED';

export interface CompanyUserResponse {
  companyId: string;
  companyName: string;
  role: CompanyUserRole;
}

export function getCompanies({ userId, accessToken }: { userId: string; accessToken?: string }) {
  return API.get<ResponseBaseWithData<{ items: CompanyUserResponse[] }>>(
    `/api/v3/users/${userId}/companies`,
    {
      params: {
        accessToken,
      },
    },
  );
}

export type FeatureItem = 'MOBILE_WEB';

interface UserFeatureFlagResponse {
  companyId: string;
  userId: string;
  enabledServerFeatures: FeatureItem[];
  disabledServerFeatures: FeatureItem[];
  enabledClientFeatures: FeatureItem[];
  disabledClientFeatures: FeatureItem[];
  evaluatedAt: string;
  totalEnabledFeatureCount: number;
}
export function getUserFeatureFlag({ companyId }: { companyId: string }) {
  return API.get<ResponseBaseWithData<UserFeatureFlagResponse>>(
    `/api/v3/companies/${companyId}/feature-control/my-features`,
  );
}

export const getReferralSummary = async (userId: string) => {
  return API.get<ResponseBaseWithData<any>>(`/api/v3/users/${userId}/referral-summary`);
};

export const getReferrals = async (userId: string) => {
  return API.get<ResponseBaseWithData<any>>(`/api/v3/users/${userId}/referrals`);
};

export const getUser = async (userId: string) => {
  return API.get<
    ResponseBaseWithData<{
      name: string;
      email: string;
    }>
  >(`/api/v3/users/${userId}`);
};

export interface UserExperimentResponse {
  experimentKey: string;
  variant: string;
}

export const getUserExperiments = async (userId: string) => {
  return API.get<ResponseBaseWithData<UserExperimentResponse[]>>(
    `/api/v3/users/${userId}/experiments`,
  );
};
